export default "__VITE_ASSET__Dlu_zVvk__"